// extracted by mini-css-extract-plugin
export var bodySections = "_7z-8";
export var gray = "_7z-7";
export var green = "_7z-4";
export var iconContainer = "_7z-9";
export var iconWidgetContainer = "_7z-1";
export var phoneIcon = "_7z-2";
export var red = "_7z-5";
export var statusDot = "_7z-3";
export var widgetContainer = "_7z-0";
export var yellow = "_7z-6";